import { metaAccount } from '@/router/meta-config'
const permissionKey = 'EVENT'

export default [
  // events
  {
    path: '/events',
    name: 'page-events',
    component: () => import('@/pages/events'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/events/:categorySlug',
    name: 'page-events-by-category',
    component: () => import('@/pages/events'),
    props: (route) => ({ categorySlug: route.params.categorySlug }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/events/:categorySlug/new',
    name: 'page-event-new',
    component: () => import('@/pages/event'),
    props: (route) => ({ categorySlug: route.params.categorySlug }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/events/:categorySlug/:id',
    name: 'page-event',
    component: () => import('@/pages/event'),
    props: (route) => ({ id: route.params.id, categorySlug: route.params.categorySlug }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
